import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { IUnitsRepository } from 'shared/domain/repositories';
import { IVectisUnit, Unit } from 'shared/infra/adapters';

export default class VectisUnitsRepository implements IUnitsRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public findById: IUnitsRepository['findById'] = async params => {
    const unit = await this.httpProvider.get<IVectisUnit | null>(
      `/unidades/${params.id}`,
    );

    if (!unit) return null;
    return new Unit(unit);
  };

  public findAll: IUnitsRepository['findAll'] = async (params = {}) => {
    const units = await this.httpProvider.get<IVectisUnit[]>('/unidades', {
      params: {
        id_cliente: params.customerId,
      },
    });

    return units.filter(unit => !unit.fechada).map(unit => new Unit(unit));
  };
}
